/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-argument */

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

// eslint-disable-next-line import/no-extraneous-dependencies
import { Server, Response } from 'miragejs';

import makeServer from './mirage';

const prepareMirage: () => void = () => {
  if (process.env.REACT_APP_ENV === 'mirage') {
    makeServer();
  }

  if (window.Cypress) {
    new Server({
      environment: 'test',
      routes() {
        const methods = ['get', 'put', 'patch', 'post', 'delete'];
        methods.forEach((method) => {
          this[method]('/*', async (schema, request) => {
            const [status, headers, body] = await window.handleFromCypress(request);
            return new Response(status, headers, body);
          });
        });
      },
    });
  }
};

export default prepareMirage;

/* eslint-enable @typescript-eslint/no-unsafe-assignment */
/* eslint-enable @typescript-eslint/no-unsafe-call */
/* eslint-enable @typescript-eslint/no-unsafe-argument */
